/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Scenario } from '@scenario/models/scenario.model';
import { Dependencies } from '@configurations/dependencies/dependencies';
import {
  retrieveScenariosFailure,
  retrieveScenariosSuccess,
} from '@store/scenario/scenarios/scenarios-slice';
import { RootState } from '@store/create-store';

export const retrieveScenariosEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('scenarios/retrieveScenarios'),
    concatMap((_action: Action) =>
      from(dependencies.scenarioGateway.retrieveAll()).pipe(
        map((scenarios: Scenario[]) => retrieveScenariosSuccess(scenarios)),
        catchError(() => of(retrieveScenariosFailure('Fail to retrieve scenarios'))),
      ),
    ),
  );
